@if (!router.url.includes('login')) {
  <app-header></app-header>
}
<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  pageSize="medium"
  color="#fff"
  type="square-jelly-box"
  [fullScreen]="true"
  ><p style="color: white">Loading...</p></ngx-spinner
>

<ngx-spinner
  name="loading"
  [fullScreen]="true"
  bdColor="rgba(0, 0, 0, 0.8)"
  pageSize="medium"
  color="#fff"
  type="square-jelly-box"
  [fullScreen]="true"
  ><p style="color: white">
    File upload in progress. Please check again after some time.
  </p></ngx-spinner
>
<router-outlet></router-outlet>
<app-footer></app-footer>
